import { render, staticRenderFns } from "./StoreIsNotAvailable.vue?vue&type=template&id=08a5d9de&lang=html"
import script from "./StoreIsNotAvailable.vue?vue&type=script&lang=js"
export * from "./StoreIsNotAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports